import { render } from "./ItemModifier.vue?vue&type=template&id=2a6faf48"
import script from "./ItemModifier.vue?vue&type=script&lang=js"
export * from "./ItemModifier.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__